import React, { useState, useEffect } from 'react';

function CountdownDisplay({ onComplete }) {  
  const [countdown, setCountdown] = useState(300); 

  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.innerHTML = "@import url('https://fonts.cdnfonts.com/css/seven-segment');";
    document.head.appendChild(styleTag);

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev > 0) {
          return prev - 1;
        } else {
          onComplete();  
          return 0;
        }
      });
    }, 1000);

    return () => {
      clearInterval(interval);
      document.head.removeChild(styleTag); 
    };
  }, [onComplete]); 

  const minutes = Math.floor(countdown / 60).toString().padStart(2, '0');
  const seconds = (countdown % 60).toString().padStart(2, '0');

  const timerStyles = {
    fontFamily: '"Seven Segment"',
    fontSize: '48px',
    color: '#ff0000',
    position: 'absolute',
    top: '10%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
  };

  const digitStyles = {
    minWidth: '30px',
    textAlign: 'center',
    lineHeight: '48px'  // Same as the fontSize we are using
  };

  const colonStyles = {
    ...digitStyles,
    position: 'relative',
    top: '-8px'  // Adjust this value as needed
  };

  return (
    <div className={"count-down-box"} style={timerStyles}>
      <span style={digitStyles}>{String(Math.floor(minutes / 10))}</span>
      <span style={digitStyles}>{String(minutes % 10)}</span>
      <span style={colonStyles}>:</span>
      <span style={digitStyles}>{String(Math.floor(seconds / 10))}</span>
      <span style={digitStyles}>{String(seconds % 10)}</span>
    </div>
  );
}

export default CountdownDisplay;
